import React, { Component } from 'react';
import { insertDataBlock } from 'megadraft';
import ImageIcon from "megadraft/lib/icons/image";

export default class BlockButton extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    const src = window.prompt('Enter the image URL');
    if (!src) return;
    const displayHeight = window.prompt('Enter a max display height (in pixels)');
    if (!displayHeight) return;
    let linkDestination = window.prompt('Enter a link destination (image itself if left blank)');
    // empty string if you hit ok, null if you cancel
    if (linkDestination === null) {
      return;
    }
    if (linkDestination === '') {
      linkDestination = src;
    }
    const data = {
      type: 'custom-image', src, displayHeight, linkDestination,
    };
    // Calls the onChange method with the new state.
    this.props.onChange(insertDataBlock(this.props.editorState, data));
  }

  render() {
    return (
      <button className={this.props.className} onClick={this.onClick}>
         <ImageIcon className="sidemenu__button__icon" />
      </button>
    );
  }
}
